<template>
    <div>
        Rate Vehicle
    </div>
</template>

<script setup lang="ts"></script>
